import React, { Component } from 'react';

import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import { getDDEActions, getFieldStateById, setFieldState } from 'graphql/operations';
import { NETWORK_ONLY } from 'graphql/fetchPolicies';

import { getDDERequiredFields } from 'selectors/assessment/selector';
import { compareValue, generateUpdateVariables, getQuestionValue } from './helper';

const SAVE_DEBOUNCE_TIME = 1500;

function SaveAnswerHOC(WrappedComponent) {
  return class SaveAnswer extends Component {
    static propTypes = {
      // TODO: Fix this...
      /* eslint-disable react/forbid-prop-types */
      client: PropTypes.object.isRequired,
      assessmentId: PropTypes.string.isRequired,
      question: PropTypes.object.isRequired,
      fieldMutation: PropTypes.func.isRequired,
      invokeActionsForFields: PropTypes.array.isRequired,
      assessment: PropTypes.object.isRequired
      /* eslint-enable react/forbid-prop-types */
    };

    constructor(props) {
      super(props);
      this.save = _.debounce(this.save, SAVE_DEBOUNCE_TIME, {
        leading: false,
        trailing: true
      });
    }

    setFieldState = variables => {
      const { client } = this.props;
      return client.mutate({
        mutation: setFieldState,
        variables,
        refetchQueries: ['listFieldsState']
      });
    };

    save = async value => {
      const { assessmentId, assessment, question, client, fieldMutation, invokeActionsForFields, ddeActionsTriggered } = this.props;
      const { id, fieldType } = question;

      const sameValue = compareValue(question, value);
      if (sameValue) return;

      const updateTime = moment().toISOString();
      const mutationArgs = {
        id,
        loading: true,
        lastUpdated: updateTime,
        fieldType,
        variables: {
          value
        }
      };

      await this.setFieldState(mutationArgs);

      fieldMutation(generateUpdateVariables(assessmentId, id, value))
        .then(async () => {
          if (invokeActionsForFields.includes(id)) {
            const result = await client.query({
              query: getDDEActions,
              variables: { id: assessmentId, invokeFieldsDetailsObject: this.getFieldDetails(question, value) },
              fetchPolicy: NETWORK_ONLY
            });
            const actions = result.data.getDDEActions;
            // Update the cache with latest actions on field change
            client.cache.writeQuery({ query: getDDEActions, variables: { id: assessmentId }, data: { getDDEActions: actions } });
            const hasRequiredField = getDDERequiredFields({ assessment, actions }).length > 0;
            ddeActionsTriggered({ variables: { assessmentId, hasRequiredField } });
          }
        })
        .catch(error => {
          console.error('save error', id, fieldType, value, error);
        })
        .finally(async () => {
          const result = await client.query({ query: getFieldStateById, variables: { id } });
          const fieldState = result.data.getFieldStateById;
          if (updateTime === fieldState.lastUpdated) {
            const updatedMutationArgs = {
              ...mutationArgs,
              loading: false
            };
            await this.setFieldState(updatedMutationArgs);
          }
        });
    };

    getFieldDetails = (question, value) => {
      const { id, fieldType } = question;
      const oldValue = getQuestionValue(question);
      let fieldDetails = {};

      if (fieldType === 'VALUES_LIST') {
        let oldValuesListId = [];
        let newValuesListId = [];
        oldValuesListId = question.possibleValues.filter(item => item.value === oldValue[0]).map(oldVlId => oldVlId.valuesListId);
        newValuesListId = question.possibleValues.filter(item => item.value === value[0]).map(newVlId => newVlId.valuesListId);
        fieldDetails = { fieldID: id, fieldType, newValue: newValuesListId, oldValue: oldValuesListId };
      } else fieldDetails = { fieldID: id, fieldType, newValue: value, oldValue };

      return fieldDetails;
    };

    render() {
      return <WrappedComponent {...this.props} save={this.save} />;
    }
  };
}

export default SaveAnswerHOC;
